export const AdVisibilityConst = ({
    ADI: {
        id: 0,
        label: 'Above the fold',
        exist: false
    },
    ARI: {
        id: 1,
        label: 'Below the fold',
        exist: false
    },
    UI: {
        id: 2,
        label: 'Unknown',
        exist: false
    }
});